import type { MyInvitation } from '../../api/types';

/** What each role is invited to do, said the way the People screen and the invitation email say it. */
const invitedTo: Record<MyInvitation['role'], string> = {
  admin: 'to run the company: people, billing and every job',
  job_manager: 'to set up and run jobs',
  scanner_operator: 'to bring documents in',
  data_entry: 'to review what Cortexa read',
};

/** One line under the company's name: who invited, and as what, in plain words. */
export function invitationLine(invitation: MyInvitation): string {
  return `${invitation.invitedBy ?? 'Someone'} invited you ${invitedTo[invitation.role]}.`;
}

/** The heading: one invitation names nothing more, several are counted. */
export function invitationsTitle(count: number): string {
  return count > 1 ? `${count} invitations` : 'You are invited';
}

/** The row under a person's companies while invitations wait. */
export function invitationsRowLabel(count: number): string {
  return count === 1 ? '1 invitation' : `${count} invitations`;
}

/** Said when an answer did not go through; the person can press again. */
export const answerFailed = 'That did not go through. Check your connection and try again.';
